import React, {useState, useEffect, useRef} from "react";
import {Link, useLocation} from "react-router-dom"

function NavMenu(props) {
    const divRef = useRef(null)
    const [open, setOpen] = useState(false)

    const location = useLocation().pathname.split('/').filter((char) => char !== '')[0]
    const pageSymbol = () => {
        switch (location) {
            case "home":
                return '~'
            case "explore":
                return '#'
            case "challenge":
                return 7
            case "about":
                return 'i'
            case "help":
                return '?'
            default:
                return ' '
        }
    }

    useEffect(() => {
        if (typeof document !== 'undefined') {
            const handleAllClicks = (event) => {
                if (!divRef.current.contains(event.target)) setOpen(false)
            }
            document.addEventListener("click", handleAllClicks)
            return () => {
                document.removeEventListener("click", handleAllClicks)
            }
        }
    }, [])

    const handleClick = () => {
        setOpen(!open)
    }

    useEffect(() => {
	    props.setOpen(open)
    }, [open])

    return (
        <div id="nav" ref={divRef} onClick={handleClick}>
            <button id="navbutton" style={open ? {color: "var(--secondary)"} : {color: "var(--secondary-light)"}}>[{pageSymbol()}]</button>
            {open && (
                <ul id="navlist">
                    <li className={pageSymbol() == '~' ? "navlistitemactive" : "navlistitem"}><Link to="/home">[~] home</Link></li>
                    <li className={pageSymbol() == '#' ? "navlistitemactive" : "navlistitem"}><Link to="/explore">[#] explore</Link></li>
                    <li className={pageSymbol() == 7 ? "navlistitemactive" : "navlistitem"}><Link to="/challenge">[7] challenge</Link></li>
                    <li className={pageSymbol() == 'i' ? "navlistitemactive" : "navlistitem"}><Link to="/about">[i] about</Link></li>
                    <li className={pageSymbol() == '?' ? "navlistitemactive" : "navlistitem"}><Link to="/help">[?] help</Link></li>
                </ul>
            )}
        </div>
    )
}

export default NavMenu
